import Tv from './Tv'

export default Tv
// eslint-disable-next-line import/export
export * from './Tv'
